<script>
import { mapActions } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, email, minLength } from "@vuelidate/validators";
import store from "../store";
import router from "../router";
import { useI18n } from "vue-i18n";
import PasswordInputComponent from "./PasswordInputComponent.vue";

export default {
  name: "LoginComponent",
  components: { PasswordInputComponent },
  setup() {
    const { t } = useI18n();
    return { t, v$: useVuelidate() };
  },
  data() {
    return {
      auth: {
        email: "",
        password: "",
      },
      errorMessage: "",
      processing: false,
    };
  },
  methods: {
    ...mapActions({
      fetchData: "auth/fetchData",
      storeToken: "auth/storeToken",
    }),
    async login() {
      this.v$.$validate();
      if (!this.v$.$error) {
        this.errorMessage = '';
        this.processing = true;
        await this.$axios.get("/csrf-cookie");
        await this.$axios
          .post("/token", this.auth)
          .then(async ({ data }) => {
            this.storeToken(data.data.token);
            await this.fetchData();
            return data;
          })
          .catch((error) => {
            this.errorMessage = error?.response?.data?.message || 'error';
          })
          .finally(() => {
            this.processing = false;
            if (store.state.auth.authenticated) {
              router.push({ name: "website" });
            }
          });
      }
    },
  },
  validations() {
    return {
      auth: {
        email: { required, email },
        password: { required, minLength: minLength(6) },
      },
    };
  },
};
</script>

<template>
  <div class="mp-form">
    <form action="#" @submit.prevent="login">
      <div class="row gy-3">
        <div
          v-if="errorMessage?.length > 0"
          class="col-12 pt-3 alert alert-danger"
        >
          {{ t("auth['Wrong Credentials']") }}
        </div>
        <div class="col-12">
          <label for="inpEmail" class="form-label" v-text="t('email')" />
          <input
            id="inpEmail"
            v-model="auth.email"
            class="form-control"
            type="email"
          />
          <div
            v-if="v$.auth.email.$errors.length > 0"
            class="pt-2 alert alert-danger"
          >
            <span v-for="error of v$.auth.email.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>
        <div class="col-12">
          <label for="inpPassword" class="form-label" v-text="t('password')" />
          <PasswordInputComponent
            id="inpPassword"
            v-model="auth.password"
            input-class="form-control"
          />
          <div
            v-if="v$.auth.password.$errors.length > 0"
            class="pt-2 alert alert-danger"
          >
            <span
              v-for="error of v$.auth.password.$errors"
              :key="error.$uid"
            >
              {{ error.$message }}
            </span>
          </div>
        </div>
        <div class="col-12 pt-3">
          <button
            class="form-control btn mp-btn-primary w-100"
            type="submit"
            :disabled="
              processing ||
              0 === auth.email.length ||
              0 === auth.password.length
            "
          >
            {{ processing ? t("pleaseWait") : t("logIn") }}
          </button>
        </div>
      </div>
    </form>
    <div class="row gy-3 pt-4">
      <div class="col-12 text-center">
        <label>
          {{ t("dontHaveAnAccount") }}
          <router-link :to="{ name: 'registration' }" class="mp-link">
            <br />{{ t("registerNow") }}
          </router-link>
        </label>
      </div>
    </div>
  </div>
</template>
